'use client';
import { FaLightbulb } from 'react-icons/fa6';
import { ErrorBoundary } from '@benzinga/core-ui';
import type { StoryObject } from '@benzinga/advanced-news-manager';
import { ClientNewsListElement } from '../../_components/markets/ClientNewsListElement';
import { BlockLayout } from './BlockLayout';

interface ExpertIdeasNewsSideWidgetProps {
  news: StoryObject[];
}

const EmptyState = () => (
  <div className="flex flex-col items-center justify-center h-full text-gray-400 py-12">
    <FaLightbulb className="text-4xl mb-3 text-gray-300" />
    <p className="text-sm font-medium text-gray-500">No expert ideas available</p>
    <p className="text-xs text-gray-400 mt-1">Check back soon for new insights</p>
  </div>
);

export const ExpertIdeasNewsSideWidget = ({ news }: ExpertIdeasNewsSideWidgetProps) => {
  return (
    <ErrorBoundary name="expert-ideas-news-side-widget">
      <BlockLayout title="Expert Ideas" actionLabel="View All" actionLink="/topic/expert-ideas" showChevron>
        <div className="flex flex-col gap-1 h-[400px] overflow-y-auto">
          {news?.length > 0 ? (
            news.map((item, index) => (
              <ClientNewsListElement
                key={index}
                article={item}
                showFull={false}
                showTicker={false}
                className="!p-2"
              />
            ))
          ) : (
            <EmptyState />
          )}
        </div>
      </BlockLayout>
    </ErrorBoundary>
  );
};

export default ExpertIdeasNewsSideWidget;
